/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { Operation } from '../../../models/common/Operation';
import { ValidationRule } from '../../ValidationRule';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends ValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasOperationIdUniquenessValidationRule extends ValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
        this.indexedOperations = <any>({});
    }

    /*private*/ indexedOperations : any;

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        if(this.hasValue(node.operationId)) {
            let dupes : Array<Operation> = /* get */((m,k) => m[k]===undefined?null:m[k])(this.indexedOperations, node.operationId);
            if(this.hasValue(dupes)) {
                this.reportIfInvalid(/* size */(<number>dupes.length) > 1, /* get */dupes[0], Constants.PROP_OPERATION_ID, this.map("operationId", node.operationId));
                this.report(node, Constants.PROP_OPERATION_ID, this.map("operationId", node.operationId));
                /* add */(dupes.push(node)>0);
            } else {
                dupes = <any>([]);
                /* add */(dupes.push(node)>0);
                /* put */(this.indexedOperations[node.operationId] = dupes);
            }
        }
    }
}
OasOperationIdUniquenessValidationRule["__class"] = "io.apicurio.datamodels.core.validation.rules.other.OasOperationIdUniquenessValidationRule";
OasOperationIdUniquenessValidationRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




